import UltMeta, { Meta } from "./UltMeta/index";
class AppType extends UltMeta {
    LIAN_YUN = new Meta(1, "链云砂石");
    CHUAN_WU = new Meta(2, "链云船务");
    DATA_SERVICE = new Meta(3, "数据服务");
}
export const APP_TYPE = new AppType();
